import axios from "axios";
import { apiURL } from "../index";
import { CentralCall } from "./CentralCall";
export const CityStateByPinCode = async (pinCode ) => {
    if (pinCode?.length === 6) {
        const Model = {
            URL: `${apiURL}api/Central/GetCityStateByPincode`, 
            Req: {
                InsurerID: 124,
                pinCode
            },
            IsPost:true
        }
        return await CentralCall(Model);
    } else return { data: { "StatusCode": 201, "Message": null, "Description": null, "TransKey": "", "Response": null } };
}